module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAGAAAAAA915G0AAAAk0lEQVRIDWNk8JstzvKfcc9/BgYdBjoCRgaGK38Y/7swDYTlIH+CPAyymwXmc01zVzr6n4Hh+sndYEcw0dVWLJaNOmA0BEZDYDQEWI4bp4CLB1N3YOlMR3D6D7AMBoLRKBgNgdEQGA2BAQ8BFmBhdAWIdU5vhZRMoNKJboCR4TzTP1YGF6CF1+hmKcwioOX/WBg8AYsXH4p1lcs2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flag-uk@2x.png
// module id = 521
// module chunks = 9